import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';

import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';

// import { TextMaskModule } from 'angular2-text-mask';

import { NgOtpInputModule } from 'ng-otp-input';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthInterceptor } from "./interceptors/auth.interceptor";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FundingAccountAchComponent } from './components/funding-account-ach/funding-account-ach.component';
import { FundingAccountCardComponent } from './components/funding-account-card/funding-account-card.component';
import { FundingAccountsComponent } from './components/funding-accounts/funding-accounts.component';
import { BrandHeaderComponent } from './components/brand-header/brand-header.component';
import { ThemeDirective } from './directives/theme.directive';
import { CustomerVerificationComponent } from './components/customer-verification/customer-verification.component';
import { CustomerVerificationFieldComponent } from './components/customer-verification-field/customer-verification-field.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { DisbursementOccurrencesComponent } from './components/disbursement-occurrences/disbursement-occurrences.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { DisbursementOccurrenceComponent } from './components/disbursement-occurrence/disbursement-occurrence.component';
import { FundingAccountComponent } from './components/funding-account/funding-account.component';
import { OtpVerificationComponent } from './components/otp-verification/otp-verification.component';

import { SharedService} from './services/shared.service';
import { SharedSignalService} from './services/shared-signal.service';
import { BrandProfileService} from './services/brand-profile.service';
import { brandProfileFactory } from './services/brand-profile-factory.service';

@NgModule({
  declarations: [
    AppComponent,
    FundingAccountAchComponent,
    FundingAccountCardComponent,
    FundingAccountsComponent,
    BrandHeaderComponent,
    ThemeDirective,
    CustomerVerificationFieldComponent,
    SpinnerComponent,
    DisbursementOccurrencesComponent,
    ConfirmationDialogComponent,
    DisbursementOccurrenceComponent,
    CustomerVerificationComponent,
    FundingAccountComponent,
    OtpVerificationComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,

    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    // RouterModule.forRoot(appRoutes),

    MatTabsModule,
    MatTableModule,
    MatCheckboxModule,
    MatButtonModule,
    MatGridListModule,
    MatCardModule,
    MatDialogModule,

    // TextMaskModule,

    FontAwesomeModule,
    NgOtpInputModule
  ],
  providers: [ {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
   },

   {
    provide: APP_INITIALIZER,
    useFactory: brandProfileFactory,
    deps: [BrandProfileService, SharedService, SharedSignalService],
    multi: true,
  },

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  // entryComponents: [ConfirmationDialogComponent],
})
export class AppModule { }
